import { Injectable } from '@angular/core';
import { LoadingController, AlertController } from '@ionic/angular';
import { ToastController } from '@ionic/angular';
@Injectable()
export class HelperService {

  public loading: any;
  private toasts: HTMLIonToastElement[] = [];

  constructor(public loadingController: LoadingController,
    public toastController: ToastController,
    public alertController: AlertController,) { }
    
  public async loaderShow(message = 'Loading...') {
    this.loading = await this.loadingController.create({
      message,
    });
    await this.loading.present();
  }

  public async loaderHide() {
    if(this.loading)
    await this.loading.dismiss();
  }

  async presentToast(msg, duration = 2500, onDismissal = null, stack = false) {
    const toast = await this.toastController.create({
      message: msg,
      duration: duration,
      position: 'top'
    });

    if (stack) {
      toast.onDidDismiss().then(() => {
        this.toasts.shift()
        if (this.toasts.length > 0) {
          this.show()
        }
      });
      this.toasts.push(toast);
      if (this.toasts.length === 1) {
        this.show()
      }
    } else {
      if (onDismissal) {
        console.log(onDismissal)
        toast.onDidDismiss().then(onDismissal);
      }
      toast.present();
    }
    
  }

  show() {
    this.toasts[0].present();
  }
}
